import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";
import ModalTemplate from "./text.modal.html";

let TextModalModule = Angular.module('text-modal', []);

export let Name = 'textModal';

class TextModal extends Service {
    static $name = Name;
    static $inject = ['$q', '$modalDelegate', '$translate'];

    show(options) {
        let args = {
            title: options.title,
            text: options.text
        };

        if (options.title) {
            this.$translate(options.title).then((translation) => {
                args.title = translation;
            });
        }

        this.$modalDelegate.show({
            scope: this.$scope,
            template: ModalTemplate,
            args: args,
            backdropClickToClose: false,

            onSave: (text) => {
                if (options.onSave) {
                    options.onSave(text);
                }

                return text;
            }
        });
    }
}

new Loader(TextModalModule)
    .load(TextModal);

export default TextModalModule;



// WEBPACK FOOTER //
// ./src/modules/core/components/test-modal/text.modal.js